simpleTest = require 'lib/experiments/simple-test'
localizeCount = require 'lib/localize-count'
React = require 'react'
ldclient = require 'lib/ldclient'
l = require 'lib/localize'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_sidebar')

module.exports = class SidebarComponent extends React.Component
  render: t.renderable ->
    {
      teamsCount, membersCount, selectedTab, onSidebarTabClick,
      enterpriseMembersCount, enterpriseMaxMembers,
      outsideCollaboratorsCount, ssoUsersCount, deactivatedCount,
      nearMaxMembers, atMaxMembers,
      memberCounts, hasRelatedEnterprises, parentEnterprise, totalMembers
      licensesLoading, userTypesLoading, pendingRequestsCount,
      publicBoardsCount
    } = @props

    t.div ->
      t.div '.enterprise-dash-sidebar', ->
        t.div '.header', ->
          t.format 'enterprise-administration'

        t.hr()

        isEnglish = /^en/.test(window.locale)

        t.ul '.enterprise-sidebar-list', ->
          t.li '.enterprise-sidebar-list-item-teams', ->
            t.b ->
              onSidebarTabClick('teams')
            , '.link', { class: t.classify('is-active': selectedTab == 'teams') }, ->
              t.text l ['view title', 'teams']

          t.li '.enterprise-sidebar-list-item-pending-teams', ->
            t.b ->
              onSidebarTabClick('teams/pending')
            , '.link.indented', { class: t.classify('is-active': selectedTab == 'teams/pending') }, ->
              t.format 'pending-requests-count', { pendingRequestsCount }

          t.li '.enterprise-sidebar-list-item-members', ->
            t.b ->
              onSidebarTabClick('members')
            , '.link', { class: t.classify('is-active': selectedTab == 'members') }, ->
              t.text l ['view title', 'members']

          t.li '.enterprise-sidebar-list-item-settings', ->
            t.b ->
              onSidebarTabClick('settings')
            , '.link', { class: t.classify('is-active': selectedTab == 'settings') }, ->
              t.format 'team-settings'

          t.li '.enterprise-sidebar-list-item-public-boards', ->
            t.b ->
              onSidebarTabClick('boards/public')
            , '.link', { class: t.classify('is-active': selectedTab == 'boards/public') }, ->
              t.format 'public-boards-count', { publicBoardsCount }

        t.div '.enterprise-dash-stats', ->
          if userTypesLoading
            t.div '.spinner', { title: 'Loading statistics…' }
            return

          t.p ->
            # temporary quick fix for English only
            _translate = (string) ->
              membersCount =
                if isEnglish
                  if enterpriseMembersCount == 1
                    '1 billable team member'
                  else
                    "#{enterpriseMembersCount} billable team members"
                else
                  localizeCount('members', enterpriseMembersCount)

              t.format string, { membersCount }

            _translate 'member-count'

          if isEnglish && deactivatedCount
            t.p ->
              t.text localizeCount('deactivated count', deactivatedCount)

          if outsideCollaboratorsCount || ssoUsersCount
            t.p ->
              if outsideCollaboratorsCount && ssoUsersCount
                t.format 'collaborators-and-sso-users-count',
                  outsideCollaboratorsCount: localizeCount(
                    'outside collaborators',
                    outsideCollaboratorsCount
                  )
                  ssoUsersCount: localizeCount(
                    'sso users',
                    ssoUsersCount
                  )
              else if outsideCollaboratorsCount
                t.format 'collaborators-count',
                  outsideCollaboratorsCount: localizeCount(
                    'outside collaborators',
                    outsideCollaboratorsCount
                  )
              else if ssoUsersCount
                t.format 'sso-users-count',
                  ssoUsersCount: localizeCount(
                    'sso users',
                    ssoUsersCount
                  )

              t.format 'theyre-free'

        if enterpriseMaxMembers
          t.div '.enterprise-dash-licenses',
            class: t.classify
              'loaded': !licensesLoading
              'seat-limit-near': nearMaxMembers
              'seat-limit-reached': atMaxMembers
          , ->
            if licensesLoading
              t.div '.spinner', { title: 'Loading statistics…' }
              return

            unless !enterpriseMaxMembers
              if hasRelatedEnterprises
                t.div ->
                  if parentEnterprise
                    t.format 'license-count-has-parent',
                      parentDisplayName: parentEnterprise.displayName,
                  else
                    t.format 'license-count-has-children'

                    t.ul ->
                      for item in memberCounts
                        t.li ->
                          { displayName, count } = item
                          t.format 'related-enterprise-billable-members', { displayName, count }
              t.div ->
                t.format 'enterprise-licenses-used'
              t.p ->
                t.format 'license-count', {
                  totalMembers,
                  enterpriseMaxMembers
                }

              if atMaxMembers
                t.format 'at-max-members'
              else if nearMaxMembers
                availableLicenses = enterpriseMaxMembers - totalMembers
                if availableLicenses == 1
                  t.format 'remaining-license-count-singular'
                else
                  t.format 'remaining-license-count-plural', { availableLicenses }



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/sidebar-component.coffee